import { Component, Inject, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RoleNomenclature, RoleNomenclatureMap } from '../../../../shared/nomenclatures/role-nomenclature';
import { ExpirienceLevelEnum, ExpirienceLevelNomenclatureMap } from '../../../nomenclatures/expirience-level-nomenclature';
import { AuthService } from '../../../../core/service/auth.service';
import { RegisterRequest } from '../../../../core/models/register-request.model';
import { UpdateUserRequest } from '../../../../core/models/update-user-request.model';
import { User } from '../../../models/user.model';
import { UserStatus } from '../../../nomenclatures/user-status-nomenclature';

@Component({
  selector: 'app-employee-dialog',
  standalone: false,
  templateUrl: './employee-dialog.component.html'
})
export class EmployeeDialogComponent implements OnInit {
  private fb = inject(FormBuilder);
  public dialogRef = inject(MatDialogRef<EmployeeDialogComponent>); 
  
  @Inject(MAT_DIALOG_DATA) public data: User;

  form: FormGroup;
  isEditMode = false;
  isLoading = false;
  showPassword = false;

  roles = Array.from(RoleNomenclatureMap.values());
  experienceLevels = Array.from(ExpirienceLevelNomenclatureMap.entries()).map(([k, v]) => ({ id: k, name: v }));

  constructor(@Inject(MAT_DIALOG_DATA) public injectedData: any, private authService: AuthService) {
    this.data = injectedData;
  }

  ngOnInit() {
    this.isEditMode = !!this.data;
    this.initForm();
  }

  initForm() {
    this.form = this.fb.group({
      username: [this.data?.username || '', [Validators.required, Validators.minLength(3)]],
      email: [this.data?.email || '', [Validators.required, Validators.email]],
      password: ['', this.isEditMode ? [] : [Validators.required]],
      roleId: [this.data?.roleId || RoleNomenclature.EMPLOYEE, [Validators.required]],
      experienceLevelId: [this.data?.expirienceLevelId || ExpirienceLevelEnum.ROOKIE, [Validators.required]],
      isActive: [this.data?.userStatus == UserStatus.ACTIVE ? true : false]
    });
  }

  get f() { return this.form.controls; }

  get passwordErrors(): string[] {
    const password = this.form.get('password')?.value || '';
    if (!password && this.isEditMode) return [];
    if (!password && !this.isEditMode) return [];

    const errors: string[] = [];
    
    if (password.length < 8) {
        errors.push('Паролата трябва да е поне 8 символа');
    }
    if (!/[A-Z]/.test(password)) {
        errors.push('Трябва да съдържа поне една главна буква');
    }
    if (!/[a-z]/.test(password)) {
        errors.push('Трябва да съдържа поне една малка буква');
    }
    if (!/[0-9]/.test(password)) {
        errors.push('Трябва да съдържа поне една цифра');
    }
    if (!/[~!@#$%^&*_\-+=`|(){}[\]:;"'<>,.?/]/.test(password)) {
        errors.push('Трябва да съдържа поне един специален символ');
    }
    
    return errors;
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  onSubmit() {
        if (this.form.invalid || (this.passwordErrors.length > 0)) return;

        this.isLoading = true;
        const formValue = this.form.value;

        if (this.isEditMode) {
            if (!formValue.password) delete formValue.password;

            const updateRequest: UpdateUserRequest = {
                userId: this.data.userId,
                username: formValue.username,
                email: formValue.email,
                roleId: Number(formValue.roleId),
                experienceLevelId: Number(formValue.experienceLevelId),
                isActive: formValue.isActive
            };

            this.authService.updateUser(updateRequest).subscribe({
                next: () => this.dialogRef.close(true),
                error: (err) => {
                    console.error(err);
                    this.isLoading = false;
                }
            });

        } else {
            const registerRequest: RegisterRequest = {
                username: formValue.username,
                email: formValue.email,
                password: formValue.password,
                roleId: Number(formValue.roleId),
                experienceLevelId: Number(formValue.experienceLevelId)
            };

            this.authService.registerUser(registerRequest).subscribe({
                next: () => this.dialogRef.close(true),
                error: (err) => {
                    console.error(err);
                    this.isLoading = false;
                }
            });
        }
    }
}